require("../src/scss/components/checkout/checkout.scss");
require("../src/js/lib/payment/checkout.js");
require("../src/js/lib/payment/jquery.payment.js");



